import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import Screen from 'src/Libs/installation-statement/components/Modals/ModalState/Screen'
import { getThemedBlankViewImage } from 'src/Libs/utils'
import { BlankViewImageVariants } from 'src/Components/blank-view'

interface Props {
  onClose: () => void
  onBack: () => void
}

const InterimSaveError: React.FC<Props> = ({ onClose, onBack }) => {
  const { t } = useCustomTranslation()
  const blankViewImageWorried = getThemedBlankViewImage(BlankViewImageVariants.Worried)

  return (
    <Screen
      title={t('installation-statement.modal-state.interim-save-error.title')}
      body={t('installation-statement.modal-state.interim-save-error.body')}
      imageSource={blankViewImageWorried}
      hasFooter={true}
      onClose={onClose}
      onBack={onBack}
    />
  )
}

export default InterimSaveError
